<template>
  <TheNuxtLink
    :to="url"
    :title="name"
    class="element_card flex flex-row-reverse overflow-hidden rounded bg-white shadow-normal shadow-gray-400 transition-shadow hover:shadow-blue-400/50 tablet:flex-col"
  >
    <figure
      class="relative block aspect-video w-2/5 shrink-0 overflow-hidden bg-gray-100 tablet:w-full"
    >
      <img
        :src="thumbnail"
        :alt="name"
        loading="lazy"
        class="pointer-events-none absolute left-0 top-0 block h-full w-full object-cover"
      />
    </figure>
    <div class="flex flex-1 flex-col p-4 tablet:p-5">
      <p class="mb-2 text-base font-bold tablet:line-clamp-2">
        {{ name }}
      </p>
      <p class="mb-2 line-clamp-4 flex-1 text-sm text-gray-600">
        {{ description }}
      </p>
      <div class="hidden tablet:flex tablet:justify-end">
        <div
          class="element_arrow flex h-8 w-8 basis-8 items-center justify-center rounded text-blue-400"
        >
          <IconArrow class="h-5 w-5" direction="right" />
        </div>
      </div>
    </div>
  </TheNuxtLink>
</template>

<script setup lang="ts">
  export interface ITopicProductCard {
    name: string;
    description: string;
    thumbnail: string;
    url: string;
  }

  defineProps<ITopicProductCard>();
</script>

<style lang="scss" scoped>
  .element_card:hover {
    .element_arrow {
      @apply bg-blue-400 text-white;
    }
  }
</style>
